module.exports = {
	extends: [
		'/',
		'base',
		'mediaManagement',
		'media'
	],

	config: {
		listComponentClass: 'base_mediaManagement_file_fileList',
		listElementComponentClass: 'base_form_media_file_file',
		nrOfElementsComponentClass: 'base_mediaManagement_file_nrOfElements',
		listNewElementContainerClass: '.newFiles',
		getCategorizedMediaActionName: 'getCategorizedFiles'
	},

	methods: {
		dataDealer: function () {
			this.model.fieldConfig = this.getResourceRegisterContent('fieldConfig') || {}
			this.model.managementConfig = this.model.fieldConfig.managementConfig || {}
		}
	}
}